<div class="modal fade" :id="modalComponentId" tabindex="-1" role="dialog" :aria-labelledby="modalComponentId + 'Label'" aria-hidden="true">
    <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" :id="modalComponentId + 'Label'">{{modalHeading}}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="onModalCloseClick">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            
            <div class="modal-body">
                <div class="alert alert-success alert-dismissible fade show" role="alert" v-if="showSuccessMessage">
                    {{successMessage}}
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="clearMessageAlerts">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="showErrorMessage">
                    {{errorMessage}}
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="clearMessageAlerts">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="alert alert-warning alert-dismissible fade show" role="alert" v-if="showWarningMessage">
                    {{warningMessage}}
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="clearMessageAlerts">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="alert alert-danger fade show" role="alert" v-if="orderValidationRulesResults !== null && orderValidationRulesResults.length > 0">
                    <div v-for="orderValidationRulesResult in orderValidationRulesResults">
                        <p v-if="!orderValidationRulesResult.isValid">
                            {{orderValidationRulesResult.message}}
                        </p>
                    </div>
                </div>
                <div v-if="!showSuccessMessage && !showErrorMessage && !showWarningMessage">
                    
                    <div class="form-group">
                        <label>Vehicles</label>
                        <div class="text-danger" v-if="order.vehicleId.hasError">
                            {{order.vehicleId.errorMessage}}
                        </div>
                        <bootstrap-select  :selectOptions="vehicles" :selectedOption="order.vehicleId.value" :elementId="'vehicleSelect'"
                                           :returnSelectedOptionText="true"
                                           @changeSelect="onVehicleSelect"></bootstrap-select>
                    </div>
                    <div class="form-group">
                        <label>Manifest Number</label>
                        <div class="text-danger" v-if="order.manifestNumber.hasError">
                            {{order.manifestNumber.errorMessage}}
                        </div>
                        <input class="form-control" type="text" v-model="order.manifestNumber.value"/>
                    </div>
                    <div class="form-group">
                        <label>Depot</label>
                        <div class="text-danger" v-if="order.depotId.hasError">
                            {{order.depotId.errorMessage}}
                        </div>
                        <bootstrap-select  :selectOptions="depots" :selectedOption="order.depotId.value" :elementId="'depotSelect'"
                                           :returnSelectedOptionText="true"
                                           @changeSelect="onDepotSelect"></bootstrap-select>
                    </div>
                    <div class="pt-3">
                        <label>Select Product</label>
                        <div class="text-danger" v-if="order.productsHasError">
                            {{order.productsErrorMessage}}
                        </div>
<!--                        <product-select-for-order :orderTypeId="orderTypeId"-->
<!--                                                  :companyId="customerShippingAddress.companyId"-->
<!--                                                  @productSelected="onProductSelected"></product-select-for-order>-->
                        <product-select-collection-order
                                :depotId="order.depotId.value"
                                @productSelected="onProductSelected"></product-select-collection-order>
                    </div>
                </div>
                
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-success" @click="onModalSaveClick" :disabled="loading" v-if="!showSuccessMessage && !showErrorMessage && !showWarningMessage">PLACE ORDER</button>
                <button type="button" class="btn btn-secondary" :disabled="loading" data-dismiss="modal" @click="onModalCloseClick" v-if="!showSuccessMessage && !showErrorMessage && !showWarningMessage">CLOSE</button>
                <button type="button" class="btn btn-primary" :disabled="loading" v-if="showSuccessMessage || showErrorMessage || showWarningMessage" @click="clearMessageAlerts">OK</button>
            </div>
        </div>
    </div>
</div>